import React, { PureComponent } from 'react';
import { CancelToken } from 'axios';
import API, { baseUrl } from '../../../utils/api';
import { translate } from '../../../utils/translations';
import {
    buildLanguageConfig,
    removeAccents,
    hasItTooMuchLuminosity,
} from '../../../utils/utils';
import { parse } from 'qs';
import '../Form.css';
import {
    DEFAULT_CONFIG,
    WIDGET_NAMES,
    WIDGET_TYPE,
    WIDGET_DIMENSIONS,
    ALTERNATIVE_TITLE_MAX_LENGTH,
} from '../../../utils/globals';
import Monochrome from '../FormPartials/Monochrome';
import ChartInputs from '../FormPartials/ChartInputs';
import WindSpeedInput from '../FormPartials/WindSpeedInput';
import TempFormatInput from '../FormPartials/TempFormatInput';

const {
    location,
    city,
    alternativeTitle,
    widgetType,
    color,
    tempFormat,
    windSpeedFormat,
    mainChart,
    secondaryChart,
} = DEFAULT_CONFIG;

export class Form8d48h extends PureComponent {
    state = {
        config: buildLanguageConfig({}),
        data: [],
        citiesWithoutAccents: [],
        location: location,
        widgetUrl: '',
        iframeCode: '',
        suggestions: [],
        // Form Inputs
        city: city,
        alternativeTitle: alternativeTitle,
        language: this.props.language,
        widgetType: widgetType,
        color: color,
        colorString: color,
        tempFormat: tempFormat,
        errorMessageNoCity: false,
        errorMessageColor: false,
        // Specific Inputs Of Municipal48h
        windSpeedFormat: windSpeedFormat,
        mainChart: mainChart,
        secondaryChart: secondaryChart,
        // Errors from Axios
        getMunicipisError: false,
    };

    render() {
        return (
            <div className="Form8d48h form" onClick={this.eraseSuggestions}>
                <h2 className="configurador__heading">
                    {translate(this.props.language, 'form_title_main')}
                </h2>
                <hr />
                <form>
                    <h3 className="form__heading">
                        {translate(
                            this.props.language,
                            'form_title_city_town_type'
                        )}
                    </h3>
                    <div className="form__section">
                        <div className="form__item">
                            <label htmlFor="city">
                                {translate(this.props.language, 'label_city')}
                            </label>
                            <input
                                name="city"
                                id="city"
                                className="input-city"
                                type="text"
                                value={this.state.city}
                                onChange={this.handleChange}
                                onFocus={this.resetCityFields}
                            />
                        </div>
                        <div className="form__item">
                            <label htmlFor="alternativeTitle">
                                {translate(
                                    this.props.language,
                                    'label_alternative_title'
                                )}
                            </label>
                            <input
                                name="alternativeTitle"
                                id="alternativeTitle"
                                type="text"
                                className="input-title"
                                value={this.state.alternativeTitle}
                                onChange={this.handleChange}
                                maxLength={ALTERNATIVE_TITLE_MAX_LENGTH}
                            />
                        </div>
                        <div className="form__item">
                            <label htmlFor="language">
                                {translate(
                                    this.props.language,
                                    'label_language'
                                )}
                            </label>
                            <select
                                name="language"
                                id="language"
                                className="select-language"
                                value={this.state.language}
                                onChange={this.handleChange}
                            >
                                <option value="ca">Català</option>
                                <option value="es">Castellano</option>
                                <option value="en">English</option>
                            </select>
                        </div>
                    </div>
                    {this.state.getMunicipisError && (
                        <span className="error-message error-message-municipis">
                            {/* TODO translate */}
                            No s'han pogut carregar els pobles
                        </span>
                    )}
                    {this.state.errorMessageNoCity &&
                        !this.state.getMunicipisError && (
                            <span className="error-message">
                                {translate(
                                    this.props.language,
                                    'form_err_no_city'
                                )}
                            </span>
                        )}
                    <ul className="suggestions">
                        {Object.keys(this.state.suggestions).map(key => (
                            <li
                                key={key}
                                data-value={this.state.suggestions[
                                    key
                                ].code.toString()}
                                tabIndex="0"
                                onClick={this.selectMatch}
                                onKeyPress={this.selectMatchOnEnter}
                                className="suggested-city"
                            >
                                {this.state.suggestions[key].name}
                            </li>
                        ))}
                    </ul>
                    <hr />
                    <h3 className="form__heading">
                        {translate(
                            this.props.language,
                            'form_title_widget_style'
                        )}
                    </h3>
                    <div className="form__section">
                        <div className="form__item">
                            <label htmlFor="widgetType">
                                {translate(this.props.language, 'label_type')}
                            </label>
                            <select
                                name="widgetType"
                                id="widgetType"
                                value={this.state.widgetType}
                                onChange={this.handleChange}
                                className="select-corporate"
                            >
                                <option value={WIDGET_TYPE.corporate}>
                                    {translate(
                                        this.props.language,
                                        'label_corporate'
                                    )}
                                </option>
                                <option value={WIDGET_TYPE.monochrome}>
                                    {translate(
                                        this.props.language,
                                        'label_monochrome'
                                    )}
                                </option>
                            </select>
                        </div>
                        {this.state.widgetType === WIDGET_TYPE.monochrome && (
                            <Monochrome
                                language={this.props.language}
                                colorString={this.state.colorString}
                                color={this.state.color}
                                handleChange={this.handleChange}
                                errorMessageColor={this.state.errorMessageColor}
                            />
                        )}
                    </div>
                    <hr />
                    <h3 className="form__heading">
                        {translate(
                            this.props.language,
                            'form_title_data_format'
                        )}
                    </h3>
                    <div className="form__section">
                        <TempFormatInput
                            language={this.props.language}
                            tempFormat={this.state.tempFormat}
                            handleChange={this.handleChange}
                        />
                        {this.props.widget === WIDGET_NAMES.municipal48h && (
                            <WindSpeedInput
                                language={this.props.language}
                                windSpeedFormat={this.state.windSpeedFormat}
                                handleChange={this.handleChange}
                            />
                        )}
                    </div>
                    {this.props.widget === WIDGET_NAMES.municipal48h && (
                        <ChartInputs
                            language={this.props.language}
                            mainChart={this.state.mainChart}
                            secondaryChart={this.state.secondaryChart}
                            handleChange={this.handleChange}
                        />
                    )}
                </form>
                <div className="iframeCode">
                    <p className="iframeP">{this.state.iframeCode}</p>
                </div>
            </div>
        );
    }

    async componentDidMount() {
        const search = this.props.location ? this.props.location.search : '';

        const config = buildLanguageConfig(parse(search), {
            ignoreQueryPrefix: true,
        });
        this.setState({ config });

        this.cancelTokenSource = CancelToken.source();
        try {
            let data = await API.getMunicipis(this.cancelTokenSource.token);
            const cities = data.data;
            cities.forEach(
                city => (city.nomWithoutAccents = removeAccents(city.nom))
            );
            this.setState({ data: cities });
        } catch (e) {
            if (e.response.status >= 404) {
                this.setState({ getMunicipisError: true });
            }
        }

        this.generateUrl();
    }

    componentWillUnmount() {
        this.cancelTokenSource.cancel(
            translate(this.props.language, 'cancelled_request')
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.city !== prevState.city && this.state.city !== '') {
            this.displayMatches();
        }

        if (this.props.language !== prevProps.language) {
            this.setState({ language: this.props.language });
        }

        this.generateUrl();

        // Update widget preview
        let key = '';

        if (this.state.location !== prevState.location) key = 'location';
        if (this.state.color !== prevState.color) key = 'color';
        if (this.state.language !== prevState.language) key = 'language';
        if (this.state.windSpeedFormat !== prevState.windSpeedFormat)
            key = 'windSpeedFormat';
        if (this.state.tempFormat !== prevState.tempFormat) key = 'tempFormat';
        if (this.state.windSpeedFormat !== prevState.windSpeedFormat)
            key = 'windSpeedFormat';
        if (this.state.mainChart !== prevState.mainChart) key = 'mainChart';
        if (this.state.secondaryChart !== prevState.secondaryChart)
            key = 'secondaryChart';

        if (key) this.props.updateWidget([key], this.state[key]);

        if (this.state.alternativeTitle !== prevState.alternativeTitle)
            this.props.updateAltTitle(
                'alternativeTitle',
                this.state.alternativeTitle
            );
    }

    handleChange = event => {
        const target = event.target;
        const value =
            target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (
            (name === 'color' || name === 'colorString') &&
            hasItTooMuchLuminosity(value)
        ) {
            this.setState({
                color: DEFAULT_CONFIG.color,
                errorMessageColor: true,
            });
            return;
        }

        this.setState({
            [name]: value,
        });

        if (name === 'color') this.setState({ colorString: value });
        if (name === 'colorString') this.setState({ color: value });
        if (name === 'widgetType' && value === WIDGET_TYPE.corporate)
            this.setState({ color: color });
    };

    eraseSuggestions = event => {
        if (event.target.nodeName === 'LI' || event.target.name === 'city')
            return;
        this.setState({ suggestions: [] });
    };

    displayMatches = () => {
        const cities =
            this.state.data && this.state.data.length ? this.state.data : [];
        const wordToMatch = removeAccents(this.state.city);

        const matchArray = cities.filter(place => {
            const regex = new RegExp(wordToMatch, 'gi');
            return place.nomWithoutAccents.match(regex);
        });

        const suggestions = matchArray.map(place => {
            return {
                code: [place.codi],
                name: `${place.nom} (${place.comarca.nom})`,
            };
        });

        this.setState({ suggestions });
    };

    resetCityFields = () => {
        this.setState({
            location: '',
            city: '',
            suggestions: [],
            iframeCode: '',
        });
        this.setState({ errorMessageNoCity: true, iframeCode: '' });
    };

    selectMatch = e => {
        const location = e.target.getAttribute('data-value');
        const city = e.target.textContent;
        const suggestions = [];

        this.setState({
            location,
            city,
            suggestions,
            errorMessageNoCity: false,
        });
    };

    selectMatchOnEnter = e => {
        if (e.key === 'Enter') {
            this.selectMatch(e);
        }
    };

    generateUrl = () => {
        const {
            alternativeTitle,
            meteoSky,
            meteoTemperature,
            meteoRainProbability,
            color,
            language,
            tempFormat,
            windSpeedFormat,
            mainChart,
            secondaryChart,
            location,
        } = this.state;

        const { widget } = this.props;

        if (location === '') return;
        this.setState({ errorMessageNoCity: false });

        const iFrameTitle =
            widget === WIDGET_NAMES.municipal48h
                ? translate(language, 'municipal_48h_title')
                : translate(language, 'municipal_8d_title');

        const altTitle = alternativeTitle
            ? `&alternativeTitle=${alternativeTitle}`
            : '';
        const sky = meteoSky ? `&estCel=${meteoSky}` : '';
        const temperatures = meteoTemperature
            ? `&temp=${meteoTemperature}`
            : '';
        const rainProbability = meteoRainProbability
            ? `&rain=${meteoRainProbability}`
            : '';
        const colorTrimmed = color.replace('#', '');
        const dimensions =
            widget === WIDGET_NAMES.municipal8d
                ? WIDGET_DIMENSIONS.municipal8d
                : WIDGET_DIMENSIONS.municipal48h;

        const windFormat =
            widget === WIDGET_NAMES.municipal48h
                ? `&windSpeedFormat=${windSpeedFormat}`
                : '';

        const charts =
            widget === WIDGET_NAMES.municipal48h
                ? `&mainChart=${mainChart}&secondaryChart=${secondaryChart}`
                : '';

        const checkedBaseUrl = baseUrl ? baseUrl : '';

        const generatedUrl = `${checkedBaseUrl}${widget}?location=${location}${altTitle}&language=${language}&color=${colorTrimmed}${sky}${temperatures}${rainProbability}&tempFormat=${tempFormat}${windFormat}${charts}`;

        const iframeCode = `<iframe src="${generatedUrl}"
        title="${iFrameTitle}" frameborder="0" style="border: 0" scrolling="no" width="${
            dimensions.width
        }" height="${dimensions.height}"></iframe>`;
        this.setState({ widgetUrl: generatedUrl, iframeCode });
    };
}



// WEBPACK FOOTER //
// ./src/containers/Configurador/Form8d48h/Form8d48h.js